import * as Swiper from 'swiper/js/swiper.js';

export default class initHpSliderBanner {
    constructor() {
        this.container = document.querySelector('.cp-hp-slider-banner');
        if (this.container === null) return;

        this.slider = document.querySelector('.js-hp-slider-banner');

        this.initSlider();

    }

    initSlider(slider) {
        new Swiper(this.slider, {
            fadeEffect: {
                crossFade: true
            },
            effect: 'fade',
            slidesPerView: 1,
            loop: true,
            pagination: true,
            preventClicks: true,
            simulateTouch: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                clickable: true,
                el: '.swiper-pagination',
                type: 'bullets',
                bulletClass: 'pagination-item',
                bulletActiveClass: '-current',
                renderBullet: function(index, className) {
                    if (this.slides[index + 1].getAttribute('data-title') !== "") {
                        return '<div class="' + className + '">' + this.slides[index + 1].getAttribute('data-title') + '</div>';
                    }
                    else {
                        return '<div class="' + className + '">' + (index + 1) + '</div>';
                    }
                }
            },
        });
    }
}
